// import { Router } from "@angular/router";
// import { environment } from "src/environments/environment";


export class AppCommon {
    
    // static mainRouter: Router;

    constructor() { }

    static getloggedInObject() {
        return JSON.parse(localStorage.getItem("loggedInUserDesk")) || undefined;
    }

    static getRole() {
        return JSON.parse(localStorage.getItem("loggedInUserDesk")).user.roles  ;
    }

    static hasDeploymentPermission(loggedObject?: any) {
        const permissions = (loggedObject || this.getloggedInObject())?.user?.permission || [];
        return ['Add DeploymentNotification', 'Update DeploymentNotification'].every(requiredPermission =>
            permissions.some(permission => permission?.name === requiredPermission)
        );
    }

    // to get status of logged in user
    static isLoggedIn() {
        if (
            this.getloggedInObject() != undefined &&
            this.getloggedInObject() != null &&
            this.getloggedInObject().token != undefined &&
            this.getloggedInObject().token != ""
        ) {
            return true;
        } else {
            return false;
        }
    }

    static clearStorage(){
        localStorage.clear();
    }

    static setLoggedInObject(e){
        localStorage.setItem("loggedInUserDesk", JSON.stringify(e));
    }

    static setGoogleUserObject(e){
        localStorage.setItem("googleUserProfile", JSON.stringify(e));
    }

    static getGoogleUserObject() {
        return JSON.parse(localStorage.getItem("googleUserProfile")) || undefined;
    }

    static getPrioritiesData(){
        return {
            results: [
                {id: 1, name: "Low"},
                {id: 2, name: "Medium"},
                {id: 3, name: "High"}
            ]
        }
    }



    // static getTeams(order){
    //     var mainList = [];
    //     var teams = JSON.parse(localStorage.getItem("loggedInUserDesk"))?.user.teams || undefined;
    //     if(teams){
    //         if(order === 'id'){
    //             mainList = teams.map(el => {return el.name;})
    //         }

    //         else if(order === 'name'){
    //             mainList = teams.map(el => {return el.name;})
    //         } 

    //         else {
    //             mainList = teams;
    //         }
    //     }
    //     return mainList
    // }

    // static getUserTeamIds(){
    //     return this.getTeams('id');
    // }

    // static getUserTeamNames(){
    //     return this.getTeams('name');
    // }

    // static getUserTeams(){
    //     return this.getTeams('all');
    // }

    // static getBaseApiUrl(){
    //     return environment.api_url
    // }
    
}
